import { ProgressBarSimplified } from "../../ProgressBarSimplified/ProgressBarSimplified";
import { CustomLimits } from "@/types/CustomLimits";

type TableCellContentLimitsProps = {
  value: CustomLimits;
};

export const TableCellContentLimits: React.FC<TableCellContentLimitsProps> = ({
  value,
}) => {
  return (
    <ProgressBarSimplified
      current={value?.count || 0}
      total={value?.limit || 0}
    />
  );
};
